import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0C0D12] mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-md bg-[#00E5FF] flex items-center justify-center">
              <GraduationCap className="w-5 h-5 text-black" />
            </div>
            <span className="font-heading font-bold text-lg">Capacita<span className="text-[#00E5FF]">Pro</span></span>
          </div>
          <p className="font-body text-sm text-[#8A8D98] max-w-sm leading-relaxed">
            Capacitación profesional en Ingeniería Civil, Contabilidad, Administración, Informática, Sistemas e Inteligencia Artificial, con certificación.
          </p>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-[#525560] mb-4">Plataforma</h4>
          <ul className="space-y-3 font-body text-sm text-[#8A8D98]">
            <li><Link to="/cursos" className="hover:text-[#00E5FF] transition-colors">Todos los cursos</Link></li>
            <li><Link to="/verificar" className="hover:text-[#00E5FF] transition-colors">Verificar certificado</Link></li>
            <li><Link to="/register" className="hover:text-[#00E5FF] transition-colors">Crear cuenta</Link></li>
            <li><Link to="/login" className="hover:text-[#00E5FF] transition-colors">Ingresar</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-[#525560] mb-4">Pagos</h4>
          <ul className="space-y-3 font-body text-sm text-[#8A8D98]">
            <li>Tarjeta de débito / crédito</li>
            <li>Yape</li>
            <li>Pago seguro</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center">
        <p className="font-mono text-xs text-[#525560]">© {new Date().getFullYear()} CapacitaPro. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}
